import { useState } from "react";
import { useHistory } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import { useAppConfig, useBuildStatus } from "../../../../hooks/DevAppHooks";
import IsLoading from "../../../../util/loader/IsLoading";
import styles from "./BuildHistory.module.scss";
import ReactTooltip from "react-tooltip";
import info from "../../../../Assets/info.svg";
import releaseNotes from "../../../../Assets/applifecycle/release-notes.svg";
import forceUpdateIcon from "../../../../Assets/applifecycle/force-update.svg";
import ReleaseNotesModal from "../../../../components/consolecomponents/modal/ReleaseNotesModal";
import RemarksModal from "../../../../components/consolecomponents/modal/RemarksModal";
import { appStatus } from "../../../../util/helpers/statusHelper";
import { getStatus, sliceString } from "../../../../util/helpers/funcHelper";
import img from "./../../../../Assets/info.svg";
import ConsoleLocalStorage from "../../../../storage/storage";
const BuildHistory = ({ app, isLoading: appLoading, isError: appError }) => {
  const history = useHistory();
  const [showReleaseNotes, setShowReleaseNotes] = useState(false);
  const [showRemarks, setShowRemarks] = useState(false);
  const [build, setBuild] = useState("");

  const {
    data,
    isLoading: buildHistoryLoading,
    isError: buildHistoryError,
  } = useBuildStatus(app.id, "");
  const { data: configData } = useAppConfig(
    ConsoleLocalStorage.getOrganization().tags
  );
  if (appLoading || buildHistoryLoading) {
    return <IsLoading />;
  }

  const handleReleaseModal = (item) => {
    setBuild(item);
    setShowReleaseNotes(true);
  };

  const handleRemarkModal = (item) => {
    setBuild(item);
    setShowRemarks(true);
  };

  return (
    <>
      <div className={styles.body}>
        <div className={styles.buildHistory}>
          <table
            className={styles.buildStatusTable}
            style={{ textAlign: "center" }}
          >
            <tr
              style={{
                height: "50px",
                borderBottom: "1px solid rgba(110, 110, 110, 1)",
              }}
            >
              <th>Build Name</th>
              <th>Version Code</th>
              <th>Size</th>
              <th>Status</th>
              <th>Created</th>
              <th>Published date</th>
              <th>Devices</th>
              <th>Release notes</th>
              <th>Force Update</th>
              <th>Remarks </th>
            </tr>
            {data.map((item) => (
              <tr>
                <td className={styles.tooltip}>
                  {sliceString(0, 10, item.version, true)}
                  {item.version.length > 10 ? (
                    <>
                      <a className="publisher_i_btn">
                        <img
                          data-class="myTooltipClass"
                          data-tip={item.version}
                          src={info}
                          alt="category-icon"
                        />
                      </a>
                      <ReactTooltip
                        arrowColor="transparent"
                        backgroundColor="#707070"
                        place="right"
                        type="dark"
                        effect="solid"
                        delayShow={100}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                </td>

                <td>{item.packageCode ? item.packageCode : "-"}</td>
                <td>{Math.ceil(item.size / 1024)} MB</td>
                <td>{getStatus(item?.status, appStatus?.release, true)}</td>
                <td>{item.created_at}</td>
                <td>{item.updated_at}</td>
                <td
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-evenly",
                    gap: "4px",
                    padding: "12px",
                  }}
                >
                  {item.platform.map((plat) => {
                    let index = configData?.platform?.[app.appOS]?.findIndex(
                      (item) => item.value === plat
                    );
                    if (index > -1) {
                      return (
                        <img
                          src={configData?.platform?.[app.appOS][index].icon}
                          style={{ width: "40px", height: "40px" }}
                          alt=""
                        />
                      );
                    }
                  })}
                </td>
                <td>
                  <img
                    src={releaseNotes}
                    className="ws-30 c-pointer"
                    onClick={() => handleReleaseModal(item)}
                    alt=""
                  />
                </td>
                <td>
                  {
                    (item.forceUpdate == true) && 
                    <Tooltip title={item.minUpdVerName || "-"} placement="bottom">
                    <img
                      src={forceUpdateIcon}
                      className="ws-30 c-pointer force-update-icon"
                      style={{ borderRadius: "100px", background: "#404040", padding: "9px" }}
                      alt=""
                    />
                    </Tooltip>
                  }
                </td>
                <td>
                  <button
                    className={`btn-tess ${item.status === 2
                      ? "active"
                      : "btn-disabled c-pointer-block"
                      }`}
                    onClick={() => {
                      handleRemarkModal(item);
                    }}
                  >
                    Remarks
                  </button>
                </td>
              </tr>
            ))}
          </table>
        </div>
      </div>
      <ReleaseNotesModal
        showReleaseNotes={showReleaseNotes}
        setShowReleaseNotes={setShowReleaseNotes}
        build={build}
      />
      <RemarksModal
        showRemarks={showRemarks}
        setShowRemarks={setShowRemarks}
        build={build}
      />
    </>
  );
};

export default BuildHistory;
